import { render, staticRenderFns } from "./tipModal.vue?vue&type=template&id=86cea3dc&scoped=true&name=modalTip&"
import script from "./tipModal.vue?vue&type=script&lang=js&"
export * from "./tipModal.vue?vue&type=script&lang=js&"
import style0 from "./tipModal.vue?vue&type=style&index=0&id=86cea3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cea3dc",
  null
  
)

export default component.exports